<template>
  <div class="main-page-view-list">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-image v-if="item.img" class="left-img-img" :src="item.img" :preview-src-list="[item.img]" preview-teleported="true" />
        <img v-else class="left-img" src="../../assets/main/akl-avg.png">
      </el-col>
      <el-col :span="16">
        <div class="check-day">
          日期:&nbsp;&nbsp;&nbsp;{{ item.date }}
        </div>
        <!-- 气温模块 -->
        <div v-if="item.weather === 1" class="check-weather-dis">
          天气:&nbsp;&nbsp;&nbsp;&nbsp; 晴
          &nbsp;&nbsp;
          <svg t="1724831645199" class="icon-weather" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="1475" width="200" height="200">
            <path d="M509.44 514.048m-260.608 0a260.608 260.608 0 1 0 521.216 0 260.608 260.608 0 1 0-521.216 0Z"
                  fill="#EDA915" p-id="1476"></path>
            <path
                d="M509.44 179.712c-11.776 0-21.504-9.728-21.504-21.504V105.984c0-11.776 9.728-21.504 21.504-21.504 11.776 0 21.504 9.728 21.504 21.504v52.224c0 11.776-9.728 21.504-21.504 21.504zM313.344 243.2c-9.216 6.656-23.04 4.608-29.696-4.608l-30.72-42.496c-6.656-9.216-4.608-23.04 4.608-29.696 9.216-6.656 23.04-4.608 29.696 4.608l30.72 42.496c6.656 9.728 4.608 23.04-4.608 29.696zM191.488 410.624c-3.584 11.264-15.872 17.408-26.624 13.824l-49.664-16.384c-11.264-3.584-17.408-15.872-13.824-26.624 3.584-11.264 15.872-17.408 26.624-13.824l49.664 16.384c11.264 3.584 17.408 15.36 13.824 26.624zM191.488 616.96c3.584 11.264-2.56 23.04-13.824 26.624l-49.664 16.384c-11.264 3.584-23.04-2.56-26.624-13.824-3.584-11.264 2.56-23.04 13.824-26.624l49.664-16.384c11.264-3.072 23.04 3.072 26.624 13.824zM312.832 784.384c9.216 6.656 11.776 20.48 4.608 29.696l-30.72 42.496c-6.656 9.216-20.48 11.776-29.696 4.608-9.216-6.656-11.776-20.48-4.608-29.696l30.72-42.496c7.168-9.216 20.48-11.264 29.696-4.608zM509.44 848.384c11.776 0 21.504 9.728 21.504 21.504v52.224c0 11.776-9.728 21.504-21.504 21.504-11.776 0-21.504-9.728-21.504-21.504v-52.224c0.512-12.288 10.24-21.504 21.504-21.504zM706.048 784.384c9.216-6.656 23.04-4.608 29.696 4.608l30.72 42.496c6.656 9.216 4.608 23.04-4.608 29.696-9.216 6.656-23.04 4.608-29.696-4.608l-30.72-42.496c-6.656-9.216-4.608-23.04 4.608-29.696zM827.904 617.472c3.584-11.264 15.872-17.408 26.624-13.824l49.664 16.384c11.264 3.584 17.408 15.872 13.824 26.624-3.584 11.264-15.872 17.408-26.624 13.824l-49.664-16.384c-11.776-3.584-17.92-15.872-13.824-26.624zM827.904 410.624c-3.584-11.264 2.56-23.04 13.824-26.624l49.664-16.384c11.264-3.584 23.04 2.56 26.624 13.824 3.584 11.264-2.56 23.04-13.824 26.624l-49.664 16.384c-11.264 3.584-23.04-2.56-26.624-13.824zM706.048 243.2c-9.216-6.656-11.776-20.48-4.608-29.696l30.72-42.496c6.656-9.216 20.48-11.776 29.696-4.608 9.216 6.656 11.776 20.48 4.608 29.696l-30.72 42.496c-6.656 9.728-19.968 11.776-29.696 4.608z"
                fill="#EDA915" p-id="1477"></path>
          </svg>
        </div>
        <div v-if="item.weather === 2" class="check-weather-dis">
          天气:&nbsp;&nbsp;&nbsp;&nbsp; 多云
          &nbsp;&nbsp;
          <svg t="1724831836555" class="icon-weather" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="1623" width="200" height="200">
            <path d="M657.408 438.272m-189.952 0a189.952 189.952 0 1 0 379.904 0 189.952 189.952 0 1 0-379.904 0Z"
                  fill="#EDA915" p-id="1624"></path>
            <path
                d="M657.408 194.56c-8.704 0-15.36-7.168-15.36-15.36v-38.4c0-8.704 7.168-15.36 15.36-15.36 8.704 0 15.36 7.168 15.36 15.36V179.2c0 8.192-6.656 15.36-15.36 15.36zM514.048 241.152c-6.656 5.12-16.896 3.584-21.504-3.584l-22.528-30.72c-5.12-6.656-3.584-16.896 3.584-21.504 6.656-5.12 16.896-3.584 21.504 3.584l22.528 30.72c5.12 6.656 3.584 16.384-3.584 21.504zM425.472 513.536c2.56 8.192-2.048 16.896-9.728 19.456l-36.352 11.776c-8.192 2.56-16.896-2.048-19.456-9.728-2.56-8.192 2.048-16.896 9.728-19.456l36.352-11.776c8.192-3.072 16.896 1.536 19.456 9.728zM514.048 635.392c6.656 5.12 8.192 14.848 3.584 21.504l-22.528 30.72c-5.12 6.656-14.848 8.192-21.504 3.584-6.656-5.12-8.192-14.848-3.584-21.504l22.528-30.72c5.12-7.168 14.848-8.704 21.504-3.584zM657.408 681.984c8.704 0 15.36 7.168 15.36 15.36v38.4c0 8.704-7.168 15.36-15.36 15.36-8.704 0-15.36-7.168-15.36-15.36v-38.4c0-8.704 6.656-15.36 15.36-15.36zM800.768 635.392c6.656-5.12 16.896-3.584 21.504 3.584l22.528 30.72c5.12 6.656 3.584 16.896-3.584 21.504-6.656 5.12-16.896 3.584-21.504-3.584l-22.528-30.72c-5.12-6.656-3.584-16.384 3.584-21.504zM889.344 513.536c2.56-8.192 11.264-12.8 19.456-9.728l36.352 11.776c8.192 2.56 12.8 11.264 9.728 19.456-2.56 8.192-11.264 12.8-19.456 9.728l-36.352-11.776c-8.192-2.56-12.288-11.264-9.728-19.456zM889.344 363.008c-2.56-8.192 2.048-16.896 9.728-19.456l36.352-11.776c8.192-2.56 16.896 2.048 19.456 9.728 2.56 8.192-2.048 16.896-9.728 19.456l-36.352 11.776c-8.192 2.56-16.896-1.536-19.456-9.728zM800.768 241.152c-6.656-5.12-8.192-14.848-3.584-21.504l22.528-30.72c5.12-6.656 14.848-8.192 21.504-3.584 6.656 5.12 8.192 14.848 3.584 21.504l-22.528 30.72c-5.12 6.656-14.848 8.704-21.504 3.584z"
                fill="#EDA915" p-id="1625"></path>
            <path
                d="M851.456 673.28c0-94.208-80.896-171.008-180.224-171.008S491.008 578.56 491.008 673.28v171.008h182.272c98.304-1.536 178.176-77.312 178.176-171.008z"
                fill="#EAEAEA" p-id="1626"></path>
            <path
                d="M737.792 665.088c0-54.272-24.576-102.912-62.976-136.192 0.512-5.12 1.024-10.24 1.024-15.36 0-98.816-80.896-179.2-180.224-179.2s-180.224 80.384-180.224 179.2c0 1.536 0 3.584 0.512 5.12-22.528-11.264-48.128-17.408-74.752-17.408-94.72 0-171.52 76.8-171.52 171.52 0 92.672 73.728 167.936 165.888 171.008v0.512h330.752v-0.512c94.72-4.096 171.52-82.432 171.52-178.688z"
                fill="#F7F7F7" p-id="1627"></path>
          </svg>
        </div>
        <div v-if="item.weather === 3" class="check-weather-dis">
          天气:&nbsp;&nbsp;&nbsp;&nbsp; 小雨
          &nbsp;&nbsp;
          <svg t="1724831868061" class="icon-weather" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="1773" width="200" height="200">
            <path
                d="M544.768 891.904c-9.216 33.792-43.52 53.76-77.312 44.544-33.792-9.216-53.76-43.52-44.544-77.312 9.216-33.792 88.064-84.48 88.064-84.48s42.496 83.456 33.792 117.248z"
                fill="#16A9D4" p-id="1774"></path>
            <path
                d="M937.984 489.984c0-103.424-88.576-186.88-197.12-186.88-109.056 0-197.12 83.968-197.12 186.88v186.88h199.68c107.52-1.536 194.56-84.48 194.56-186.88z"
                fill="#EAEAEA" p-id="1775"></path>
            <path
                d="M813.568 480.768c0-59.392-26.624-112.64-69.12-148.992 0.512-5.632 1.024-11.264 1.024-16.896 0-108.544-88.576-196.096-197.12-196.096S350.72 206.848 350.72 315.392c0 2.048 0 3.584 0.512 5.632-24.576-12.288-52.736-18.944-81.92-18.944C165.888 301.568 81.92 385.536 81.92 489.472c0 101.376 80.896 183.808 181.248 187.392v0.512h361.984v-0.512c104.96-4.608 188.416-90.624 188.416-196.096z"
                fill="#F7F7F7" p-id="1776"></path>
          </svg>
        </div>
        <div v-if="item.weather === 4" class="check-weather-dis">
          天气:&nbsp;&nbsp;&nbsp;&nbsp; 大雨
          &nbsp;&nbsp;
          <svg t="1724831901885" class="icon-weather" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="1922" width="200" height="200">
            <path
                d="M504.32 919.552c-7.68 28.16-36.352 44.544-64.512 37.376-28.16-7.68-44.544-36.352-37.376-64.512 7.68-28.16 73.216-70.144 73.216-70.144s36.352 69.12 28.672 97.28zM352.768 791.552c-8.192 30.72-39.936 49.152-70.656 40.96-30.72-8.192-49.152-39.936-40.96-70.656 8.192-30.72 80.384-76.8 80.384-76.8s39.424 75.776 31.232 106.496zM707.072 806.4c-8.704 32.768-42.496 52.224-75.264 43.52-32.768-8.704-52.224-42.496-43.52-75.264 8.704-32.768 85.504-81.92 85.504-81.92s41.984 80.896 33.28 113.664z"
                fill="#16A9D4" p-id="1923"></path>
            <path
                d="M924.672 425.984c0-100.352-86.016-181.76-192-181.76s-192 81.408-192 181.76v181.76h194.048c105.472-1.024 189.952-81.92 189.952-181.76z"
                fill="#EAEAEA" p-id="1924"></path>
            <path
                d="M803.84 417.28c0-57.856-26.112-109.568-67.072-144.896 0.512-5.632 1.024-10.752 1.024-16.384 0-105.472-86.016-190.464-192-190.464S354.304 151.04 354.304 256.512c0 2.048 0 3.584 0.512 5.632-24.064-11.776-51.2-18.432-79.36-18.432-100.864 0-182.272 81.408-182.272 182.272 0 98.816 78.336 178.688 176.64 181.76v0.512h351.744v-0.512c100.864-4.608 182.272-88.064 182.272-190.464z"
                fill="#F7F7F7" p-id="1925"></path>
          </svg>
        </div>
        <div v-if="item.weather === 5" class="check-weather-dis">
          天气:&nbsp;&nbsp;&nbsp;&nbsp; 雷雨
          &nbsp;&nbsp;
          <svg t="1724831931832" class="icon-weather" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="2071" width="200" height="200">
            <path
                d="M321.536 834.048c-8.704 32.768-42.496 52.224-75.264 43.52-32.768-8.704-52.224-42.496-43.52-75.264 8.704-32.768 85.504-81.92 85.504-81.92s41.984 80.896 33.28 113.664zM757.248 906.24c-7.68 28.672-37.376 45.568-66.048 37.888-28.672-7.68-45.568-37.376-37.888-66.048 7.68-28.672 75.264-71.68 75.264-71.68s36.352 70.656 28.672 99.84z"
                fill="#16A9D4" p-id="2072"></path>
            <path
                d="M939.008 441.856c0-103.424-88.576-186.88-197.12-186.88s-197.12 83.968-197.12 186.88v186.88h199.68c107.52-1.536 194.56-84.48 194.56-186.88z"
                fill="#EAEAEA" p-id="2073"></path>
            <path
                d="M814.592 432.64c0-59.392-26.624-112.64-69.12-148.992 0.512-5.632 1.024-11.264 1.024-16.896 0-108.544-88.576-196.096-197.12-196.096S351.744 158.72 351.744 266.752c0 2.048 0 3.584 0.512 5.632-24.576-12.288-52.736-18.944-81.92-18.944-103.424 0-187.392 83.968-187.392 187.392 0 101.376 80.896 183.808 181.248 187.392v0.512h361.984v-0.512c104.96-4.608 188.416-90.112 188.416-195.584z"
                fill="#F7F7F7" p-id="2074"></path>
            <path d="M524.288 502.272l-16.896 202.24H370.176z" fill="#EDA915" p-id="2075"></path>
            <path d="M459.776 900.608l16.896-202.24h137.216z" fill="#EDA915" p-id="2076"></path>
          </svg>
        </div>
        <div v-if="item.weather === 6" class="check-weather-dis">
          天气:&nbsp;&nbsp;&nbsp;&nbsp; 小雪
          &nbsp;&nbsp;
          <svg t="1724831962215" class="icon-weather" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="2222" width="200" height="200">
            <path
                d="M937.984 462.336c0-103.424-88.576-186.88-197.12-186.88-109.056 0-197.12 83.968-197.12 186.88v186.88h199.68c107.52-1.024 194.56-84.48 194.56-186.88z"
                fill="#EAEAEA" p-id="2223"></path>
            <path
                d="M813.568 453.12c0-59.392-26.624-112.64-69.12-148.992 0.512-5.632 1.024-11.264 1.024-16.896 0-108.544-88.576-196.096-197.12-196.096S350.72 179.2 350.72 287.744c0 2.048 0 3.584 0.512 5.632-24.576-12.288-52.736-18.944-81.92-18.944C165.888 274.432 81.92 358.4 81.92 461.824c0 101.376 80.896 183.808 181.248 187.392v0.512h361.984v-0.512c104.96-4.608 188.416-90.624 188.416-196.096z"
                fill="#F7F7F7" p-id="2224"></path>
            <path
                d="M503.296 942.592c-4.096 0-7.68-3.584-7.68-7.68v-206.848c0-4.096 3.584-7.68 7.68-7.68s7.68 3.584 7.68 7.68v206.848c-0.512 4.096-3.584 7.68-7.68 7.68z"
                fill="#D8D8D8" p-id="2225"></path>
            <path
                d="M503.296 781.824c-2.048 0-3.584-0.512-5.12-2.048l-29.696-29.696c-3.072-3.072-3.072-7.68 0-10.752 3.072-3.072 7.68-3.072 10.752 0l24.576 24.576 24.576-24.576c3.072-3.072 7.68-3.072 10.752 0 3.072 3.072 3.072 7.68 0 10.752l-29.696 29.696c-2.56 1.024-4.608 2.048-6.144 2.048zM473.088 926.72c-2.048 0-3.584-0.512-5.12-2.048-3.072-3.072-3.072-7.68 0-10.752l29.696-29.696c1.536-1.536 3.072-2.048 5.12-2.048s4.096 1.024 5.12 2.048l29.696 29.696c3.072 3.072 3.072 7.68 0 10.752-3.072 3.072-7.68 3.072-10.752 0l-24.576-24.576-24.576 24.576c-0.512 1.536-2.56 2.048-4.608 2.048z"
                fill="#D8D8D8" p-id="2226"></path>
            <path
                d="M592.384 890.88c-1.024 0-2.56-0.512-3.584-1.024l-179.2-103.424c-3.584-2.048-4.608-6.656-2.56-10.24s6.656-4.608 10.24-2.56l179.2 103.424c3.584 2.048 4.608 6.656 2.56 10.24-1.536 2.048-4.096 3.584-6.656 3.584z"
                fill="#D8D8D8" p-id="2227"></path>
            <path
                d="M412.16 821.248c-3.072 0-6.144-2.048-7.168-5.632-1.024-4.096 1.536-8.192 5.12-9.216l33.792-9.216-9.216-33.792c-1.024-4.096 1.536-8.192 5.12-9.216 4.096-1.024 8.192 1.536 9.216 5.12l10.752 40.96c0.512 2.048 0 4.096-0.512 5.632-1.024 1.536-2.56 3.072-4.608 3.584l-40.96 10.752c0 1.024-0.512 1.024-1.536 1.024zM564.224 908.8c-3.072 0-6.144-2.048-7.168-5.632l-10.752-40.96c-1.024-4.096 1.536-8.192 5.12-9.216l40.96-10.752c4.096-1.024 8.192 1.536 9.216 5.12 1.024 4.096-1.536 8.192-5.12 9.216l-33.792 9.216 9.216 33.792c1.024 4.096-1.536 8.192-5.12 9.216h-2.56z"
                fill="#D8D8D8" p-id="2228"></path>
            <path
                d="M413.696 890.88c-2.56 0-5.12-1.536-6.656-3.584-2.048-3.584-1.024-8.192 2.56-10.24l179.2-103.424c3.584-2.048 8.192-1.024 10.24 2.56s1.024 8.192-2.56 10.24l-179.2 103.424c-1.024 0.512-2.56 1.024-3.584 1.024z"
                fill="#D8D8D8" p-id="2229"></path>
            <path
                d="M442.368 908.8c-0.512 0-1.536 0-2.048-0.512-4.096-1.024-6.144-5.12-5.12-9.216l9.216-33.792-33.792-9.216c-4.096-1.024-6.144-5.12-5.12-9.216 1.024-4.096 5.12-6.144 9.216-5.12l40.96 10.752c4.096 1.024 6.144 5.12 5.12 9.216l-10.752 40.96c-1.536 4.096-4.608 6.144-7.68 6.144zM593.92 821.248c-0.512 0-1.536 0-2.048-0.512l-40.96-10.752c-4.096-1.024-6.144-5.12-5.12-9.216l10.752-40.96c1.024-4.096 5.12-6.144 9.216-5.12 4.096 1.024 6.144 5.12 5.12 9.216l-9.216 33.792 33.792 9.216c4.096 1.024 6.144 5.12 5.12 9.216-0.512 3.072-3.584 5.12-6.656 5.12z"
                fill="#D8D8D8" p-id="2230"></path>
          </svg>
        </div>
        <div v-if="item.weather === 7" class="check-weather-dis">
          天气:&nbsp;&nbsp;&nbsp;&nbsp; 大雪
          &nbsp;&nbsp;
          <svg t="1724831990878" class="icon-weather" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="2376" width="200" height="200">
            <path
                d="M916.48 418.816c0-97.792-83.968-177.664-187.392-177.664s-187.392 79.36-187.392 177.664v177.664h189.44c102.912-1.536 185.344-80.384 185.344-177.664z"
                fill="#EAEAEA" p-id="2377"></path>
            <path
                d="M798.72 410.112c0-56.32-25.6-107.008-65.536-141.312 0.512-5.12 1.024-10.752 1.024-15.872 0-102.912-83.968-185.856-187.392-185.856S359.424 150.528 359.424 252.928c0 2.048 0 3.584 0.512 5.12-23.552-11.264-49.664-17.92-77.824-17.92-98.304 0-178.176 79.872-178.176 178.176 0 96.256 76.8 174.592 172.032 177.664v0.512h343.04v-0.512c99.84-4.096 179.712-85.504 179.712-185.856z"
                fill="#F7F7F7" p-id="2378"></path>
            <path
                d="M485.376 954.88c-2.56 0-5.12-2.048-5.12-5.12v-134.656c0-2.56 2.048-5.12 5.12-5.12s5.12 2.048 5.12 5.12v134.656c-0.512 3.072-2.56 5.12-5.12 5.12z"
                fill="#D8D8D8" p-id="2379"></path>
            <path
                d="M485.376 849.92c-1.024 0-2.56-0.512-3.584-1.536l-19.456-19.456c-2.048-2.048-2.048-5.12 0-6.656 2.048-2.048 5.12-2.048 6.656 0l15.872 15.872 15.872-15.872c2.048-2.048 5.12-2.048 6.656 0 2.048 2.048 2.048 5.12 0 6.656l-19.456 19.456c0 1.024-1.536 1.536-2.56 1.536zM504.832 944.64c-1.024 0-2.56-0.512-3.584-1.536l-15.872-15.872-15.872 15.872c-2.048 2.048-5.12 2.048-6.656 0-2.048-2.048-2.048-5.12 0-6.656l19.456-19.456c2.048-2.048 5.12-2.048 6.656 0l19.456 19.456c2.048 2.048 2.048 5.12 0 6.656-1.024 1.024-2.56 1.536-3.584 1.536z"
                fill="#D8D8D8" p-id="2380"></path>
            <path
                d="M543.744 921.088c-1.024 0-1.536 0-2.56-0.512l-116.736-67.072c-2.56-1.536-3.072-4.096-1.536-6.656s4.096-3.072 6.656-1.536l116.736 67.072c2.56 1.536 3.072 4.096 1.536 6.656-1.024 1.536-2.56 2.048-4.096 2.048z"
                fill="#D8D8D8" p-id="2381"></path>
            <path
                d="M425.984 876.032c-2.048 0-4.096-1.536-4.608-3.584-0.512-2.56 1.024-5.12 3.584-6.144l22.016-5.632-5.632-22.016c-0.512-2.56 1.024-5.12 3.584-6.144 2.56-0.512 5.12 1.024 6.144 3.584l7.168 26.624c0.512 1.024 0 2.56-0.512 3.584-0.512 1.024-1.536 2.048-3.072 2.048l-26.624 7.168c-1.024 0.512-1.536 0.512-2.048 0.512zM524.8 932.864c-2.048 0-4.096-1.536-4.608-3.584l-7.168-26.624c-0.512-2.56 1.024-5.12 3.584-6.144l26.624-7.168c2.56-0.512 5.12 1.024 6.144 3.584 0.512 2.56-1.024 5.12-3.584 6.144l-22.016 5.632 5.632 22.016c0.512 2.56-1.024 5.12-3.584 6.144h-1.024z"
                fill="#D8D8D8" p-id="2382"></path>
            <path
                d="M427.008 921.088c-1.536 0-3.072-1.024-4.096-2.56-1.536-2.56-0.512-5.12 1.536-6.656l116.736-67.072c2.56-1.536 5.12-0.512 6.656 1.536 1.536 2.56 0.512 5.12-1.536 6.656l-116.736 67.072c-1.024 1.024-1.536 1.024-2.56 1.024z"
                fill="#D8D8D8" p-id="2383"></path>
            <path
                d="M445.952 932.864h-1.024c-2.56-0.512-4.096-3.584-3.584-6.144l5.632-22.016-22.016-5.632c-2.56-0.512-4.096-3.584-3.584-6.144 0.512-2.56 3.584-4.096 6.144-3.584l26.624 7.168c2.56 0.512 4.096 3.584 3.584 6.144l-7.168 26.624c-0.512 2.048-2.56 3.584-4.608 3.584zM544.256 876.032h-1.024l-26.624-7.168c-2.56-0.512-4.096-3.584-3.584-6.144l7.168-26.624c0.512-2.56 3.584-4.096 6.144-3.584 2.56 0.512 4.096 3.584 3.584 6.144l-5.632 22.016 22.016 5.632c2.56 0.512 4.096 3.584 3.584 6.144-1.536 2.048-3.072 3.584-5.632 3.584z"
                fill="#D8D8D8" p-id="2384"></path>
            <path
                d="M661.504 810.496c-3.072 0-5.632-2.56-5.632-5.632v-156.672c0-3.072 2.56-5.632 5.632-5.632 3.072 0 5.632 2.56 5.632 5.632v156.672c0 3.072-2.56 5.632-5.632 5.632z"
                fill="#D8D8D8" p-id="2385"></path>
            <path
                d="M661.504 688.64c-1.536 0-3.072-0.512-4.096-1.536l-22.528-22.528c-2.048-2.048-2.048-5.632 0-8.192 2.048-2.048 5.632-2.048 8.192 0l18.944 18.944 18.944-18.944c2.048-2.048 5.632-2.048 8.192 0 2.048 2.048 2.048 5.632 0 8.192l-22.528 22.528c-2.56 1.024-3.584 1.536-5.12 1.536zM684.032 798.72c-1.536 0-3.072-0.512-4.096-1.536l-18.944-18.944-18.944 18.944c-2.048 2.048-5.632 2.048-8.192 0-2.048-2.048-2.048-5.632 0-8.192l22.528-22.528c2.048-2.048 5.632-2.048 8.192 0l22.528 22.528c2.048 2.048 2.048 5.632 0 8.192 0 1.024-1.536 1.536-3.072 1.536z"
                fill="#D8D8D8" p-id="2386"></path>
            <path
                d="M729.088 771.072c-1.024 0-2.048 0-3.072-0.512l-135.68-78.336c-2.56-1.536-3.584-5.12-2.048-7.68 1.536-2.56 5.12-3.584 7.68-2.048l135.68 78.336c2.56 1.536 3.584 5.12 2.048 7.68-0.512 1.536-2.56 2.56-4.608 2.56z"
                fill="#D8D8D8" p-id="2387"></path>
            <path
                d="M592.384 718.848c-2.56 0-4.608-1.536-5.632-4.096-1.024-3.072 1.024-6.144 4.096-7.168l25.6-6.656-6.656-25.6c-1.024-3.072 1.024-6.144 4.096-7.168 3.072-1.024 6.144 1.024 7.168 4.096l8.192 31.232c1.024 3.072-1.024 6.144-4.096 7.168l-31.232 8.192c-0.512-0.512-1.024 0-1.536 0zM707.584 784.896c-2.56 0-4.608-1.536-5.632-4.096l-8.192-31.232c-1.024-3.072 1.024-6.144 4.096-7.168l31.232-8.192c3.072-1.024 6.144 1.024 7.168 4.096 1.024 3.072-1.024 6.144-4.096 7.168l-25.6 6.656 6.656 25.6c1.024 3.072-1.024 6.144-4.096 7.168h-1.536z"
                fill="#D8D8D8" p-id="2388"></path>
            <path
                d="M593.408 771.072c-2.048 0-4.096-1.024-5.12-3.072-1.536-2.56-0.512-6.144 2.048-7.68l135.68-78.336c2.56-1.536 6.144-0.512 7.68 2.048 1.536 2.56 0.512 6.144-2.048 7.68l-135.68 78.336c-0.512 1.024-1.536 1.024-2.56 1.024z"
                fill="#D8D8D8" p-id="2389"></path>
            <path
                d="M615.424 784.896h-1.536c-3.072-1.024-4.608-4.096-4.096-7.168l6.656-25.6-25.6-6.656c-3.072-1.024-4.608-4.096-4.096-7.168s4.096-4.608 7.168-4.096l31.232 8.192c3.072 1.024 4.608 4.096 4.096 7.168l-8.192 31.232c-1.024 2.56-3.072 4.096-5.632 4.096zM730.112 718.336h-1.536l-31.232-8.192c-1.536-0.512-2.56-1.536-3.584-2.56-0.512-1.536-1.024-3.072-0.512-4.096l8.192-31.232c1.024-3.072 4.096-5.12 7.168-4.096 3.072 1.024 4.608 4.096 4.096 7.168l-6.656 25.6 25.6 6.656c3.072 1.024 4.608 4.096 4.096 7.168-0.512 2.048-3.072 3.584-5.632 3.584z"
                fill="#D8D8D8" p-id="2390"></path>
            <path
                d="M331.264 808.96c-3.584 0-6.656-3.072-6.656-6.656v-184.832c0-3.584 3.072-6.656 6.656-6.656 3.584 0 6.656 3.072 6.656 6.656v184.832c0 3.584-3.072 6.656-6.656 6.656z"
                fill="#D8D8D8" p-id="2391"></path>
            <path
                d="M331.264 664.576c-1.536 0-3.584-0.512-4.608-2.048l-26.624-26.624c-2.56-2.56-2.56-6.656 0-9.216s6.656-2.56 9.216 0l22.016 22.016 22.016-22.016c2.56-2.56 6.656-2.56 9.216 0s2.56 6.656 0 9.216l-26.624 26.624c-1.024 1.536-2.56 2.048-4.608 2.048zM304.64 794.624c-1.536 0-3.584-0.512-4.608-2.048-2.56-2.56-2.56-6.656 0-9.216l26.624-26.624c1.024-1.024 3.072-2.048 4.608-2.048 1.536 0 3.584 0.512 4.608 2.048l26.624 26.624c2.56 2.56 2.56 6.656 0 9.216s-6.656 2.56-9.216 0l-22.016-22.016-22.016 22.016c-1.536 1.536-3.072 2.048-4.608 2.048z"
                fill="#D8D8D8" p-id="2392"></path>
            <path
                d="M411.648 762.368c-1.024 0-2.048-0.512-3.584-1.024l-160.256-92.672c-3.072-2.048-4.096-6.144-2.56-9.216 2.048-3.072 6.144-4.096 9.216-2.56L414.72 750.08c3.072 2.048 4.096 6.144 2.56 9.216-1.024 2.048-3.584 3.072-5.632 3.072z"
                fill="#D8D8D8" p-id="2393"></path>
            <path
                d="M249.856 700.416c-3.072 0-5.632-2.048-6.656-5.12-1.024-3.584 1.024-7.168 4.608-8.192l30.208-8.192-8.192-30.208c-1.024-3.584 1.024-7.168 4.608-8.192 3.584-1.024 7.168 1.024 8.192 4.608l9.728 36.352c0.512 1.536 0 3.584-0.512 5.12-1.024 1.536-2.56 2.56-4.096 3.072l-36.864 9.728c0.512 1.024 0 1.024-1.024 1.024zM386.048 778.752c-3.072 0-5.632-2.048-6.656-5.12l-9.728-36.864c-1.024-3.584 1.024-7.168 4.608-8.192l36.864-9.728c3.584-1.024 7.168 1.024 8.192 4.608 1.024 3.584-1.024 7.168-4.608 8.192l-30.208 8.192 8.192 30.208c1.024 3.584-1.024 7.168-4.608 8.192-1.024 0.512-1.536 0.512-2.048 0.512z"
                fill="#D8D8D8" p-id="2394"></path>
            <path
                d="M251.392 762.368c-2.56 0-4.608-1.024-5.632-3.584-2.048-3.072-0.512-7.168 2.56-9.216l160.256-92.672c3.072-2.048 7.168-0.512 9.216 2.56 2.048 3.072 0.512 7.168-2.56 9.216l-160.256 92.672c-1.536 1.024-2.56 1.024-3.584 1.024z"
                fill="#D8D8D8" p-id="2395"></path>
            <path
                d="M276.992 778.752h-1.536c-3.584-1.024-5.632-4.608-4.608-8.192l8.192-30.208-30.208-8.192c-3.584-1.024-5.632-4.608-4.608-8.192 1.024-3.584 4.608-5.632 8.192-4.608l36.864 9.728c1.536 0.512 3.072 1.536 4.096 3.072 1.024 1.536 1.024 3.584 0.512 5.12l-9.728 36.352c-1.536 3.072-4.096 5.12-7.168 5.12zM412.672 700.416h-1.536l-36.864-9.728c-3.584-1.024-5.632-4.608-4.608-8.192l9.728-36.864c1.024-3.584 4.608-5.632 8.192-4.608 3.584 1.024 5.632 4.608 4.608 8.192l-8.192 30.208 30.208 8.192c3.584 1.024 5.632 4.608 4.608 8.192-0.512 2.56-3.072 4.608-6.144 4.608z"
                fill="#D8D8D8" p-id="2396"></path>
          </svg>
        </div>
        <div v-if="item.weather === 8" class="check-weather-dis">
          天气:&nbsp;&nbsp;&nbsp;&nbsp; 雾霾
          &nbsp;&nbsp;
          <svg t="1724832029148" class="icon-weather" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               p-id="2542" width="200" height="200">
            <path
                d="M944.128 449.024c0-103.424-88.576-186.88-197.12-186.88s-197.12 83.968-197.12 186.88v186.88h199.68c107.52-1.024 194.56-84.48 194.56-186.88z"
                fill="#EAEAEA" p-id="2543"></path>
            <path
                d="M820.224 439.808c0-59.392-26.624-112.64-69.12-148.992 0.512-5.632 1.024-11.264 1.024-16.896 0-108.544-88.576-196.096-197.12-196.096S357.376 165.888 357.376 274.432c0 2.048 0 3.584 0.512 5.632C332.8 267.776 305.152 261.12 275.456 261.12c-103.424 0-187.392 83.968-187.392 187.392 0 101.376 80.896 183.808 181.248 187.392v0.512h361.984v-0.512c104.96-4.608 188.928-90.624 188.928-196.096z"
                fill="#F7F7F7" p-id="2544"></path>
            <path d="M336.384 726.016m-33.28 0a33.28 33.28 0 1 0 66.56 0 33.28 33.28 0 1 0-66.56 0Z" fill="#D8D8D8"
                  p-id="2545"></path>
            <path d="M481.792 764.928m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z"
                  fill="#D8D8D8" p-id="2546"></path>
            <path d="M506.88 905.728m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z"
                  fill="#D8D8D8" p-id="2547"></path>
            <path d="M631.296 856.576m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z"
                  fill="#D8D8D8" p-id="2548"></path>
            <path d="M574.464 770.048m-16.896 0a16.896 16.896 0 1 0 33.792 0 16.896 16.896 0 1 0-33.792 0Z"
                  fill="#D8D8D8" p-id="2549"></path>
            <path d="M645.632 935.936m-16.896 0a16.896 16.896 0 1 0 33.792 0 16.896 16.896 0 1 0-33.792 0Z"
                  fill="#D8D8D8" p-id="2550"></path>
            <path d="M413.696 824.832m-16.896 0a16.896 16.896 0 1 0 33.792 0 16.896 16.896 0 1 0-33.792 0Z"
                  fill="#D8D8D8" p-id="2551"></path>
            <path d="M346.112 903.68m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z"
                  fill="#D8D8D8" p-id="2552"></path>
            <path d="M660.48 707.584m-32.768 0a32.768 32.768 0 1 0 65.536 0 32.768 32.768 0 1 0-65.536 0Z"
                  fill="#D8D8D8" p-id="2553"></path>
          </svg>
        </div>
        <!-- 气温模块结束 -->
        <div class="check-weather-dis">
          温度:&nbsp;&nbsp;&nbsp;&nbsp;{{ item.temperature }}
        </div>
        <div class="check-weather-dis-pro">
          <div class="dis-div">距离:&nbsp;&nbsp;{{ item.distance }}Km</div>
        </div>
        <div class="check-weather-dis-pro">
          体力:&nbsp;&nbsp;
          <el-progress v-if="item.power>=80" class="progress-ls" :percentage="item.power"
                       :color="colorOne"></el-progress>
          <el-progress v-if="item.power>=60 && item.power<80" class="progress-ls" :percentage="item.power"
                       :color="colorTwo"></el-progress>
          <el-progress v-if="item.power>=40 && item.power<60" class="progress-ls" :percentage="item.power"
                       :color="colorThree"></el-progress>
          <el-progress v-if="item.power>=20 && item.power<40" class="progress-ls" :percentage="item.power"
                       :color="colorFour"></el-progress>
          <el-progress v-if="item.power<20" class="progress-ls" :percentage="item.power"
                       :color="colorFive"></el-progress>
        </div>
        <div class="check-mood-mood">
          心情:
          <svg v-for="index in item.mood" :key="index" :style="{marginLeft: index*15+'px'}" t="1724816438554"
               class="icon-weather" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
               p-id="4497" width="200" height="200">
            <path d="M344 356h338l-20.4 439.8c-0.9 20.3-17.7 36.2-38 36.2H402.4c-20.3 0-37-16-38-36.2L344 356z"
                  fill="#FF6C6D" p-id="4498"></path>
            <path
                d="M670.8 597.4l-5.6 120.1c-26.4 1.8-51.7 1.8-75.8-0.1-69.1-5.4-104.9-92.9-179.3-132.8-11-5.9-29.7-9.5-56-10.8l-6.3-135.7c3.6 0.6 7.3 1.2 11.2 1.9 122.6 22.7 174.5 181.3 230.4 190.4 22.5 3.6 49.6-7.4 81.4-33z"
                fill="#FFFFFF" p-id="4499"></path>
            <path
                d="M670.8 597.4l-5.6 120.1c-26.4 1.8-51.7 1.8-75.8-0.1-69.1-5.4-104.9-92.9-179.3-132.8-11-5.9-29.7-9.5-56-10.8l-6.3-135.7c3.6 0.6 7.3 1.2 11.2 1.9 122.6 22.7 174.5 181.3 230.4 190.4 22.5 3.6 49.6-7.4 81.4-33z"
                fill="#FFFFFF" p-id="4500"></path>
            <path
                d="M680.2 356.8l1.8 0.1-1.8 38.1v1.5h-0.1l-18.5 399.2c-0.9 20.3-17.7 36.2-38 36.2h-62.2l30.4-435.4H332.2v-50.9h348v11.2z"
                fill="#FA3C48" p-id="4501"></path>
            <path
                d="M670.8 597.4l-5.6 120.1c-26.4 1.8-51.7 1.8-75.8-0.1-6.9-0.5-13.4-1.9-19.7-3.9l6.2-88.1c4.5 2.5 9 4.2 13.5 5 22.5 3.6 49.6-7.4 81.4-33z"
                fill="#E9F4FF" p-id="4502"></path>
            <path d="M538.2 283.5H713V356H311v-72.5h185.9v-75.1l-48.5-33.1 27.8-27.3 62 39.8z" fill="#EEF6FF"
                  p-id="4503"></path>
            <path d="M311 283.5h212V210l-73.5-52.5 29-17.5 87.5 45.5 4 98h143V326H311z" fill="#FFFFFF"
                  p-id="4504"></path>
            <path
                d="M344 356l20.4 439.8c0.9 20.3 17.7 36.2 38 36.2h221.3c20.3 0 37-16 38-36.2L682 356h31v-66.5c0-3.3-2.7-6-6-6H538.2v-95.7l-62-39.8-27.8 27.3 48.4 33v75.1H317c-3.3 0-6 2.7-6 6V356h33z m-38.2 39.7c-19.6-2.6-34.8-19.3-34.8-39.7v-66.5c0-25.4 20.6-46 46-46h139.9v-14l-31-21.1c-20.8-14.2-23.5-43.9-5.5-61.6l27.8-27.3c13.3-13.1 33.9-15.2 49.7-5.2l61.9 39.8c11.5 7.4 18.4 20 18.4 33.7v55.7H707c25.4 0 46 20.6 46 46V356c0 19.6-14.1 36-32.8 39.4l-18.7 402.3c-1.9 41.6-36.2 74.4-77.9 74.4H402.4c-41.7 0-76-32.8-77.9-74.4l-18.7-402z"
                fill="#721D0F" p-id="4505"></path>
          </svg>
        </div>
        <div class="check-mood-remark" style="margin-bottom: 5px">
          动态:&nbsp;&nbsp;&nbsp;{{ item.remark }}
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "checkBlock",
  data() {
    return {
      colorOne: '#96e6a1',
      colorTwo: '#e6e596',
      colorThree: '#80f5e3',
      colorFour: '#e6ba96',
      colorFive: '#f17cb7',
      title: '体力'
    }
  },
  props: ['item'],
  created() {

  },
}
</script>

<style scoped>
.main-page-view-list {
  margin-top: 15px;
  background-color: #fff;
  border-radius: 5px;
  min-height: 100px;
  width: 100%;
  overflow: hidden;
  transition: 1s;
}

.main-page-view-list::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-radius: 5px;
  border-top: 2px solid #96e6a1;
  border-left: 2px solid #96e6a1;
  transition: 1s;
}

.main-page-view-list::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-radius: 5px;
  border-right: 2px solid #96e6a1;
  border-bottom: 2px solid #96e6a1;
  transition: 1s;
}

.main-page-view-list:hover::before, .main-page-view-list:hover::after {
  width: 100%;
  height: 100%;
}

.main-page-view-list:hover {
  cursor: pointer;
  color: #42b8f1;
  background-color: #e7f5e1;
  box-shadow: 0 0 50px #e7f5e1;
  transition-delay: .5s;
}

.check-weather-dis {
  width: 100%;
  height: 20px;
  margin-top: 5px;
  color: #42b983;
  line-height: 20px;
  font-size: 15px;
}

.check-weather-dis-pro {
  width: 100%;
  height: 20px;
  margin-top: 5px;
  color: #8d525c;
  line-height: 20px;
  font-size: 16px;
  font-family: 幼圆;
}

.dis-div {
  position: absolute;
  width: 150px;
  height: 20px;
}

.progress-ls {
  position: absolute;
  width: 150px;
  height: 20px;
  margin-top: -20px;
  margin-left: 55px;
}

.check-day {
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  background-image: linear-gradient(-20deg, #ede9f3 0%, #d5dee8 100%);
  margin-top: 2px;
  border-radius: 5px;
}

.check-mood-mood {
  width: 100%;
  height: 20px;
  margin-top: 5px;
  line-height: 20px;
  font-size: 14px;
  font-family: 幼圆;
}

.check-mood-remark {
  width: 100%;
  height: 40px;
  margin-top: 5px;
  line-height: 20px;
  font-size: 14px;
  font-family: 幼圆;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-weather {
  position: absolute;
  width: 20px;
  height: 20px;
}

.left-img {
  width: 150px;
  height: 150px;
  margin-top: 30px;
  margin-left: 10px
}

.left-img-img {
  width: 280px;
  height: 190px;
  margin-top: 10px;
  margin-left: 10px;
  z-index: 999;
}

</style>